// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const tabsClasses = {
  indicator: "qui-tabs__indicator",
  list: "qui-tabs__list",
  panel: "qui-tabs__panel",
  root: "qui-tabs__root",
} as const

export const tabClasses = {
  button: "qui-tab__button",
  dismissButton: "qui-tab__dismiss-button",
  icon: "qui-tab__icon",
  root: "qui-tab__root",
} as const
